import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findReligions = (headers, params) => {
    let query = buildQuery(params, []);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/religions${query}`, {
        headers,
    });
};

export const findReligionById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/religions/${id}`, {
        headers
    })
}
